import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Brain, Rocket, Zap, CheckCircle, Globe } from "lucide-react";
import "./css/Strategy.css";

const Strategy = () => {
  const strategies = [
    {
      icon: <Brain size={40} />,
      label: "AI-powered",
      title: "Assess and align",
      description: "Higher Placement Rates with industry-aligned up-skilling.",
    },
    {
      icon: <Rocket size={40} />,
      title: "Deploy",
      description: "Customized Training Programs based on student needs.",
    },
    {
      icon: <Zap size={40} />,
      label: "AI-powered",
      title: "Accelerate",
      description: "Parent Confidence through transparent dashboards.",
    },
    {
      icon: <CheckCircle size={40} />,
      title: "Validate",
      description:
        "Better Admissions & Reputation with future-ready graduates.",
    },
    {
      icon: <Globe size={40} />,
      title: "Deliver",
      description: "Industry Tie-ups for internships and job referrals",
    },
  ];

  return (
    <div className="strategy-section py-5">
      <Container>
        <h2 className="strategy-title text-center mb-5">
          A strategy that works to drive the results you need
        </h2>
        <Row className="strategy-cards mb-5">
          {strategies.map((strategy, index) => (
            <Col md={2} key={index} className="mb-4">
              <div className="strategy-card text-center">
                <div className="strategy-icon">{strategy.icon}</div>
                {strategy.label && (
                  <span className="strategy-label">{strategy.label}</span>
                )}
                <h5 className="strategy-card-title">{strategy.title}</h5>
                <p className="strategy-card-description">
                  {strategy.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Strategy;
